import { getFunctions, httpsCallable } from 'firebase/functions'
import { app } from '../firebase'

const functions = getFunctions(app, 'us-central1')

class DraftService {
  /**
   * Speichert oder aktualisiert einen Entwurf
   * @param {Object} draftData - Die Entwurfsdaten
   * @param {string} draftId - Optional: ID des zu aktualisierenden Entwurfs
   * @returns {Promise<Object>} { success, id, message }
   */
  async saveDraft (draftData, draftId = null) {
    const saveDraft = httpsCallable(functions, 'saveDraft')
    const result = await saveDraft({
      ...draftData,
      draftId
    })
    return result.data
  }

  /**
   * Lädt einen einzelnen Entwurf
   * @param {string} draftId - Die ID des Entwurfs
   * @returns {Promise<Object>} { success, draft }
   */
  async loadDraft (draftId) {
    const loadDraft = httpsCallable(functions, 'loadDraft')
    const result = await loadDraft({ draftId })
    return result.data
  }

  /**
   * Löscht einen Entwurf
   * @param {string} draftId - Die ID des Entwurfs
   * @returns {Promise<Object>} { success, message }
   */
  async deleteDraft (draftId) {
    const deleteDraft = httpsCallable(functions, 'deleteDraft')
    const result = await deleteDraft({ draftId })
    return result.data
  }

  /**
   * Listet alle Entwürfe des aktuellen Users
   * @returns {Promise<Object>} { success, drafts }
   */
  async listDrafts () {
    const listDrafts = httpsCallable(functions, 'listDrafts')
    const result = await listDrafts()
    return result.data
  }
}

export default new DraftService()

